import React, { Component } from 'react';

import {
    Form, Select, Row, Col, Button,
} from 'antd';

import DoseOne from '../DosageDirectionHelper/DoseOne';
import DoseTwo from '../DosageDirectionHelper/DoseTwo';
import DoseThree from '../DosageDirectionHelper/DoseThree';
import DoseFour from '../DosageDirectionHelper/DoseFour';

const FormItem = Form.Item;
const { Option } = Select;

class UnwrappedDosageDirection extends Component {
    state = {
        dosage_direction: '',
    };

    handleChange = (value) => {
        this.setState({ dosage_direction: value });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        const { form, handleDoseDirection, changeActiveKey } = this.props;

        form.validateFields((err, values) => {
            if (!err) {
            // console.log('Received values of form: ', values);
                values.time_1 = '';
                values.direction_1 = '';
                values.time_2 = '';
                values.direction_2 = '';
                values.time_3 = '';
                values.direction_3 = '';
                values.time_4 = '';
                values.direction_4 = '';
                handleDoseDirection(values);
            }
        });

        changeActiveKey('3');
    }

    render() {
        const {
            form, data, selectedMed, changeActiveKey, handleDoseDirection,
            handleSubmitFromDosageDirection, onCancel,
        } = this.props;

        const { getFieldDecorator, getFieldValue } = form;

        const { dosage_direction } = data;

        const dosage_directions = [
            { key: 1, value: 'Once a Day' }, { key: 2, value: 'Twice a day' },
            { key: 3, value: 'Three times a day' }, { key: 4, value: 'Four times a day' },
            { key: 'SOS', value: 'SOS' },
        ];

        const medName = selectedMed.split('#')[1];

        const dosage_direction_options = dosage_directions.map(
            dd => (
                <Option key={dd.key} value={dd.key}>
                    {dd.value}
                </Option>
            ),
        );

        return (
            <div style={{ textAlign: 'center', minHeight: '390px', paddingTop: '5%' }}>

                <h5 style={{ textAlign: 'center' }}>{medName}</h5>

                <div style={{ height: '580px', overflow: 'auto' }}>

                    <Form onSubmit={this.handleSubmit}>


                        <FormItem>
                            {getFieldDecorator('dosage_direction', {
                                rules: [{ required: true, message: 'Select one please!' }],
                                initialValue: dosage_direction == null
                                    ? 'Select the dosage direction'
                                    : dosage_direction === 0
                                        ? 'SOS'
                                        : dosage_direction,
                            })(
                                <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Select the dosage direction"
                                    optionFilterProp="children"
                                    onChange={this.handleChange}
                                    filterOption={
                                        (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {dosage_direction_options}
                                </Select>,
                            )}
                        </FormItem>
                        { getFieldValue('dosage_direction') === 'Select the dosage direction'
                            ? (
                                <Row type="flex" justify="center" style={{ marginTop: '10%' }}>
                                    <Col span={12} pull={6}>
                                        <FormItem>
                                            <Button
                                                type="primary"
                                                onClick={() => changeActiveKey('1')}
                                            >
                                                To Prev
                                            </Button>
                                        </FormItem>
                                    </Col>

                                </Row>
                            )
                            : null

                        }

                        { getFieldValue('dosage_direction') === 'SOS'
                            ? (
                                <Row type="flex" justify="center" style={{ marginTop: '10%' }}>

                                    <Col span={12}>
                                        <FormItem>
                                            <Button
                                                type="primary"
                                                onClick={() => changeActiveKey('1')}
                                            >
                                                To Prev
                                            </Button>
                                        </FormItem>
                                    </Col>

                                    <Col span={12}>
                                        <FormItem>
                                            <Button type="primary" htmlType="submit">To Next</Button>
                                        </FormItem>
                                    </Col>

                                </Row>
                            )
                            : null
                        }

                    </Form>

                    { getFieldValue('dosage_direction') === 1
                        ? (
                            <DoseOne
                                data={data}
                                onCancel={onCancel}
                                changeActiveKey={changeActiveKey}
                                handleDoseDirection={handleDoseDirection}
                                handleSubmitFromDosageDirection={handleSubmitFromDosageDirection}
                            />
                        )
                        : null
                    }

                    { getFieldValue('dosage_direction') === 2
                        ? (
                            <DoseTwo
                                data={data}
                                onCancel={onCancel}
                                changeActiveKey={changeActiveKey}
                                handleDoseDirection={handleDoseDirection}
                                handleSubmitFromDosageDirection={handleSubmitFromDosageDirection}
                            />
                        )
                        : null
                    }

                    { getFieldValue('dosage_direction') === 3
                        ? (
                            <DoseThree
                                data={data}
                                onCancel={onCancel}
                                changeActiveKey={changeActiveKey}
                                handleDoseDirection={handleDoseDirection}
                                handleSubmitFromDosageDirection={handleSubmitFromDosageDirection}
                            />
                        )
                        : null
                    }

                    { getFieldValue('dosage_direction') === 4
                        ? (
                            <DoseFour
                                data={data}
                                onCancel={onCancel}
                                changeActiveKey={changeActiveKey}
                                handleDoseDirection={handleDoseDirection}
                                handleSubmitFromDosageDirection={handleSubmitFromDosageDirection}
                            />
                        )
                        : null
                    }
                </div>

            </div>
        );
    }
}

const DosageDirection = Form.create()(UnwrappedDosageDirection);
export default DosageDirection;



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/TabsComponents/DosageDirection.js